import { Path, Svg } from '@react-pdf/renderer';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const ImageOffLineSvg = ({ width = 48, height = 48, color = '#657888' }: Props) => (
  <Svg viewBox="0 0 48 48" width={width} height={height}>
    <Path
      fill={color}
      d="M0.785156 5.61328H4.78516V61.6184H0.785156V5.61328Z"
      transform="rotate(-45 0.785156 5.61328)"
    />
    <Path
      fill={color}
      d="M10.8281 10H8V38L23.4141 22.5859L26.2422 25.4141L13.6562 38H38.8281L42.6992 41.8711C42.4823 41.9521 42.2515 41.9981 42.0156 42H9.65625L9.61621 42.04L9.57422 42H5.98438C5.4581 41.9995 4.95305 41.7902 4.58105 41.418C4.20904 41.0456 4 40.54 4 40.0137V7.98633C4.00366 7.46121 4.2139 6.95849 4.58496 6.58691C4.95619 6.21531 5.45914 6.00419 5.98438 6H6.82812L10.8281 10ZM42.0156 6C43.1116 6 44 6.89033 44 7.98633V37.5156L26.2422 19.7578L28 18L40 30V10H16.4844L12.4844 6H42.0156ZM19.8623 19.0342C19.6822 19.7069 19.3291 20.3272 18.8281 20.8281C18.078 21.5783 17.0609 22 16 22C14.9391 22 13.922 21.5783 13.1719 20.8281C12.4217 20.078 12 19.0609 12 18C12 16.9391 12.4217 15.922 13.1719 15.1719C13.6727 14.6711 14.2924 14.3169 14.9648 14.1367L19.8623 19.0342Z"
    />
  </Svg>
);
